import PropTypes from "prop-types";
import React, { PureComponent } from "react";

import Icon from "../../components/interface/Icon";

class SubwayAddNodeView extends PureComponent {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    const nodeStyle = {
      left: `${this.props.x}px`,
      top: `${this.props.y}px`
    };

    const onClick = _e => this.props.onClick(this.props.threadId);

    return (
      <div onClick={onClick} className="subwayAddNode" style={nodeStyle}>
        <div className="subwayNodeText">{this.props.label}</div>
        <Icon icon="sidebarAdd" color="iconMono" />
      </div>
    );
  }
}

SubwayAddNodeView.propTypes = {
  viewId: PropTypes.string.isRequired,
  threadId: PropTypes.string.isRequired,
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  onClick: PropTypes.func,
  label: PropTypes.string.isRequired
};

export default SubwayAddNodeView;
